import React from 'react';


import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import FunciPage from './pages/Funcionario';
import DashboardAppPage from './pages/DashboardAppPage';
import SignUp from './pages/register/candiForm';

// ----------------------------------------------------------------------

export default function Routes() {

  const routes = useRoutes([
    {
      path: '/login',
      element: <LoginPage />,
    },
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'user', element: <UserPage /> },
        { path: 'funcionario', element: <FunciPage/>},
      ],
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/login" /> },
      ],
    },
    {
      path: '/',
      element: <Navigate to="/login" replace />
    },
    {
      path: '/register',
      element: <SignUp/>,
    },
  ]);

  return routes;
}
